import {
  DotLoading,
  List,
  Modal,
  Popup,
  Tag,
  Toast,
  Tabs,
  Dialog,
} from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import {
  momentDate,
  timeTableDayFromNumber,
  jsonToQuery,
  MOB_ICONS,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { FloatButton, Avatar, Space, Spin } from "antd";
import $ from "jquery";
import Header from "../header";
const LibraryList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [viewRequest, setViewRequest] = useState([]);
  const [circulationHistory, setCirculationHistory] = useState([]);
  const [validated, setValidated] = useState(false);
  const [day, setDay] = useState();

  const [fromDate, setFromDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(momentDate(new Date(), "YYYY-MM-DD"));
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    let form = new FormData();
    console.log(context.user);
    form.append("student_uuid", context.user.emp_code);
    setLoader(true);
    axios.post(ServiceUrl.MOB.LIST_ITEM_CIRCULATION, form).then((res) => {
      if (res["data"].status == "1") {
        setCirculationHistory(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    Toast.show("Processing...");
    axios
      .get(ServiceUrl.MOB.LIST_BOOK + "?" + $("#frmsearch").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };

  return (
    <>
      <Header title="Library" backAction={true} rightActions={[]} />
      {circulationHistory && circulationHistory.length > 0 && (
        <div className="">
          <div className="container mt-2">
            <Card data-aos="zoom-in">
              <Card.Header className="fw-bold">Issued Books</Card.Header>
              <Card.Body>
                <div
                  className="table-responsive "
                  style={{ overflowY: "auto", maxHeight: "300px" }}
                >
                  <table class="table table-sm table-bordered">
                    <thead class="table-light">
                      <tr>
                        <th>Title</th>
                        <th align="">Access No</th>
                        <th align="">Issued Date</th>
                        <th align="">Due Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {circulationHistory.map((item, index) => (
                        <>
                          <tr style={{ border: "1px solid #ccc" }}>
                            <td align="">{item.title}</td>
                            <td>{item.access_number}</td>
                            <td>{momentDate(item.issue_date, "DD/MM/YYYY")}</td>
                            <td>{momentDate(item.due_date, "DD/MM/YYYY")}</td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      )}

      <div className="">
        <div className="container mt-3">
          <Card data-aos="zoom-in">
            <Card.Header className="fw-bold">Book</Card.Header>
            <Card.Body>
              <Form
                method="post"
                noValidate
                validated={validated}
                id="frmsearch"
                onSubmit={handleSubmit}
              >
                <input
                  type="hidden"
                  name="employee_uuid"
                  value={context.user.uuid}
                />
                <table
                  width="100%"
                  align="center"
                  className="font-bookman"
                  cellPadding={3}
                >
                  <thead>
                    <tr>
                      <td align="center" height="30">
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name={"fields"}
                          style={{
                            border: "1px solid #9E9E9E",
                            width: "100%",
                          }}
                          id="fields"
                        >
                          <option value="all">-Select-</option>
                          <option value="access_number">Access Number</option>
                          <option value="isbn">ISBN</option>
                          <option value="title">Title</option>
                          <option value="author">Author</option>
                          <option value="issn">ISSN</option>
                          <option value="call_number">Call Number</option>
                          <option value="ddc_number">DDC Number</option>
                          <option value="oclc_number">OCLC Number</option>
                          <option value="lcc_number">LCC Number</option>
                          <option value="publisher">Publisher</option>
                          <option value="barcode">Barcode</option>
                          <option value="keywords">Keywords</option>
                        </Form.Control>
                      </td>
                    </tr>{" "}
                    <tr>
                      <td colSpan="2" style={{ height: "10px" }}></td>{" "}
                      {/* Spacer row */}
                    </tr>
                    <tr className="mt-2">
                      <td height="30">
                        <Form.Control
                          type="text"
                          name="field_value"
                          id="field_value"
                          style={{
                            border: "1px solid #9E9E9E",
                            height: "30px",
                            width: "100%",
                          }}
                          required
                          placeholder=""
                        />
                      </td>
                    </tr>{" "}
                    <tr>
                      <td colSpan="2" style={{ height: "10px" }}></td>{" "}
                      {/* Spacer row */}
                    </tr>
                    <tr className="mt-2">
                      <td align="center" height="30">
                        <Button
                          fille="outline"
                          block
                          size="sm"
                          onClick={(e) => handleSubmit(e)}
                        >
                          <i className="fa-solid fa-magnifying-glass"></i>{" "}
                          Search
                        </Button>
                        {/*  <FloatButton
                          icon={<img src={MOB_ICONS.SEARCH} />}
                          type="submit"
                          style={{
                            /*  display: "flex",
                              justifyContent: "center",
                              alignItems: "center",*
                            position: "absolute",
                            top: "55%",
                            right: 15,
                            transform: "translateY(-50%)",
                            width: "32px",
                            height: "32px",
                          }}
                          onClick={(e) => {
                            handleSubmit(e);
                          }}
                        /> */}
                      </td>
                    </tr>
                    <tr>&nbsp;</tr>
                  </thead>
                </table>
              </Form>
              <>
                {dataList && dataList.length > 0 && (
                  <div className="book">
                    <Card className="mb-2">
                      <Card.Header
                        style={{
                          position: "relative",
                          background: "#dad9d9",
                          paddingTop: "15px",
                          color: "#000",
                        }}
                      >
                        <h6 style={{ color: "#000" }}>Book List </h6>
                      </Card.Header>
                      <Card.Body>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col">Title</th>
                              <th scope="col">Author</th>
                              <th scope="col">Access No</th>
                              <th scope="col">Publisher</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataList.map((item) => (
                              <tr>
                                <td data-label="Title">{item.title}</td>
                                <td data-label="Author">{item.author}</td>
                                <td data-label="Access No">
                                  {item.access_number}
                                </td>
                                <td data-label="Publisher">{item.publisher}</td>
                                <td
                                  data-label="Status"
                                  style={{
                                    color:
                                      item.item_status === "available"
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  {item.item_status}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};
export default LibraryList;
